import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import AddCircleRoundedIcon from "@material-ui/icons/AddCircleRounded";
import CloseIcon from "@material-ui/icons/Close";
import { DropzoneArea } from "material-ui-dropzone";
import { Delete } from "@material-ui/icons";
import { toast } from "react-toastify";
import { useFetchContext } from "../../../common/FetchContext";
import { usePostReportTemplateUpload } from "../../../common/services/fileServices";
import { useAddDateByApprover, useAddDateByPM, useAddDateDelivered, useAddReportDate, usemoveToDelivered } from "../../../common/CommonQueries";

export const TechWriterDate = ({ name, report_id, workorder_id, refetch, disabled, pmName, approver_name, writer_name }: any) => {
  const [open, setOpen] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());
  const writerStartDate = "Tech_Writer_start_Date"
  const dateVerified = "date_verified_pm"
  const dateApproved = "date_approved"
  const dateDelivered = "date_delivered"
  const fileInputRef = useRef<HTMLInputElement>(null);

  const [files, setFiles] = React.useState<any[]>([]);
  const [comment, setComment] = useState("");


  const { authAxios } = useFetchContext();
  const { mutateAsync: mutatePostFile, isLoading: isLoadingFileUpload } = usePostReportTemplateUpload();
  const { mutateAsync: mutateAddDate, isLoading: isLoadingAddDate } = useAddReportDate();
  const { mutateAsync: mutateAddDateByPm, isLoading: isLoadingAddDateByPm } = useAddDateByPM();
  const { mutateAsync: mutateAddDateApproved, isLoading: isLoadingAddDateApproved } = useAddDateByApprover();
  const { mutateAsync: mutateAddDateDelivered, isLoading: isLoadingAddDateDelivered } = useAddDateDelivered();
  const { mutateAsync: mutateMoveToDelivered } = usemoveToDelivered();

  const handleToggle = () => {
    if (!open) {
      setCurrentDate(new Date());
    } else {
      setComment("")
      setFiles([])
    }
    setOpen(!open);
  };

  const handleFileUpload = async (item: any) => {
    console.log(item)
    fileInputRef.current?.click()
  };

  const handleFilePicked = (event: React.ChangeEvent<HTMLInputElement>) => {
    const uploadedFiles = event.target.files;
    if (uploadedFiles) {
      setFiles(uploadedFiles as any);
    }

  };

  const handleSubmit = async () => {


    if (!files.length) {
      toast.error("Please upload a file before submitting.");
      return;
    }

    const file = files[0];
    const currentdatetime = currentDate.toISOString();

    try {
      await mutatePostFile({
        authAxios,
        file,
        report_id,
        workorder_id,
        datetime: currentdatetime,
      });
      toast.success("File uploaded successfully!");

      await mutateAddDate({
        authAxios,
        reportId: report_id,
        date_time: currentdatetime
      });


      toast.success("TechWriter Start Date Updated  successfully!");

      await refetch();

      handleToggle();
      setFiles([]);

    } catch (error: any) {
      console.error(error);
      toast.error("Error while uploading the file!");
    }




  }

  const handleSubmitDatePM = async () => {
    const currentdatetime = currentDate.toISOString();;

    try {


      await mutateAddDateByPm({
        authAxios,
        reportId: report_id,
        date_verified: currentdatetime,
        verified_comment: comment
      });


      toast.success("Date Verified Updateed  successfully!");

      await refetch();

      handleToggle();

    } catch (error: any) {
      console.error(error);
      toast.error("Error while updating date");
    }

  }

  const handleSubmitDateApproved = async () => {
    const currentdatetime = currentDate.toISOString();;

    try {


      await mutateAddDateApproved({
        authAxios,
        reportId: report_id,
        date_approved: currentdatetime,
        approved_comment: comment
      });


      toast.success("Date Approved  Updateed  successfully!");

      await refetch();

      handleToggle();

    } catch (error: any) {
      console.error(error);
      toast.error("Error while updating date");
    }

  }

  const handleSubmitDateDelivered = async () => {
    const currentdatetime = currentDate.toISOString();;

    try {

      await mutateAddDateDelivered({
        authAxios,
        reportId: report_id,
        date_delivered: currentdatetime,
        delivered_comment: comment
      });

      toast.success("Deliverd Date Updated  successfully!");

      // await mutateMoveToDelivered({
      //   report_result_id: report_id,
      //   authAxios,
      // });

      // toast.success("Report is moved to Delivered!");

      await refetch();


      handleToggle();

    } catch (error: any) {
      console.error(error);
      toast.error("Error while updating date");
    }

  }




  return (
    <>
      <Tooltip title="Add Date">
        <IconButton

          onClick={!disabled ? handleToggle : undefined}
          disabled={disabled}

        >
          <AddCircleRoundedIcon color={disabled ? "disabled" : "primary"} />

        </IconButton>
      </Tooltip>


      {name === writerStartDate &&
        <Dialog
          open={open}
          onClose={handleToggle}
          aria-labelledby="dialog-title"
          fullWidth
          maxWidth="md"
        >
          <DialogTitle>
            <Grid container justifyContent="space-between" alignItems="center">
              <Typography variant="h6">Tech Writer Start Date</Typography>
              <IconButton onClick={handleToggle}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </DialogTitle>

          <Divider />

          <DialogContent dividers>
            <Grid container spacing={3}>

              <Grid item xs={6}>
                <Typography variant="subtitle1" gutterBottom>
                  Tech Writer Starts
                </Typography>
              </Grid>


              <Grid item xs={3}>
                From :{writer_name}

              </Grid>
              <Grid item xs={2}>
                At : {currentDate.toLocaleString()}

              </Grid>
              <Grid item xs={9}>
                <Grid item xs={12}>
                  <Typography variant="h5" color="primary" >Upload Report File <img onClick={handleFileUpload} src="/file_upload.svg" alt="Custom Icon" width="30" height="30" /></Typography>
                </Grid>
                <Grid item xs={4}>

                  <input
                    ref={fileInputRef}
                    type="file"
                    style={{ display: 'none' }}
                    onChange={handleFilePicked}
                  />
                  {files.length != 0 && <div style={{ position: "relative", display: "inline-block" }}>
                    <img src="/file_icon.png" alt="Custom Icon" height={200} width={200} />
                    <IconButton
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px",
                        background: "lightgray",
                        color: "black",
                        border: "none",
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                      }}
                      onClick={() => setFiles([])}
                    >
                      <Delete></Delete></IconButton>
                  </div>}
                </Grid>

              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleToggle} color="secondary" variant="outlined">
              Close
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={handleSubmit}
              disabled={isLoadingFileUpload || isLoadingAddDate}
            >
              {isLoadingFileUpload || isLoadingAddDate ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Add"
              )}
            </Button>
          </DialogActions>
        </Dialog>
      }


      {name === dateVerified &&
        <Dialog
          open={open}
          onClose={handleToggle}
          aria-labelledby="dialog-title"
          fullWidth
          maxWidth="md"
        >
          <DialogTitle>
            <Grid container justifyContent="space-between" alignItems="center">
              <Typography variant="h6">Verification Info</Typography>
              <IconButton onClick={handleToggle}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </DialogTitle>

          <Divider />

          <DialogContent dividers>
            {/* First Row */}
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <Typography variant="subtitle1" gutterBottom>
                  Verified by PM
                </Typography>
              </Grid>

              <Grid item xs={3}>
                Verified By : {pmName}
              </Grid>

              <Grid item xs={2}>
                At : {currentDate.toLocaleString()}
              </Grid>
            </Grid>

            {/* Second Row: New Grid for TextField */}
            <Grid container spacing={3} style={{ marginTop: 16 }}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Comments"
                  variant="outlined"
                  size="small"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
              </Grid>
            </Grid>
          </DialogContent>


          <DialogActions>
            <Button onClick={handleToggle} color="secondary" variant="outlined">
              Close
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={handleSubmitDatePM}
              disabled={isLoadingAddDateByPm}
            >
              {isLoadingAddDateByPm ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Add"
              )}
            </Button>

          </DialogActions>
        </Dialog>
      }

      {name === dateApproved &&
        <Dialog
          open={open}
          onClose={handleToggle}
          aria-labelledby="dialog-title"
          fullWidth
          maxWidth="md"
        >
          <DialogTitle>
            <Grid container justifyContent="space-between" alignItems="center">
              <Typography variant="h6">Approval Info</Typography>
              <IconButton onClick={handleToggle}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </DialogTitle>

          <Divider />

          <DialogContent dividers>
            {/* First Row */}
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <Typography variant="subtitle1" gutterBottom>
                  Approved by Approver
                </Typography>
              </Grid>

              <Grid item xs={3}>
                Approved By : {approver_name}
              </Grid>

              <Grid item xs={2}>
                At : {currentDate.toLocaleString()}
              </Grid>
            </Grid>

            {/* Second Row: New Grid for TextField */}
            <Grid container spacing={3} style={{ marginTop: 16 }}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Comments"
                  variant="outlined"
                  size="small"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
              </Grid>
            </Grid>
          </DialogContent>


          <DialogActions>
            <Button onClick={handleToggle} color="secondary" variant="outlined">
              Close
            </Button>
            <Button color="primary" variant="contained" onClick={handleSubmitDateApproved} disabled={isLoadingAddDateApproved}>
              {isLoadingAddDateApproved ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Add"
              )}
            </Button>
          </DialogActions>
        </Dialog>
      }

      {name === dateDelivered &&
        <Dialog
          open={open}
          onClose={handleToggle}
          aria-labelledby="dialog-title"
          fullWidth
          maxWidth="md"
        >
          <DialogTitle>
            <Grid container justifyContent="space-between" alignItems="center">
              <Typography variant="h6">Delivery Info</Typography>
              <IconButton onClick={handleToggle}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </DialogTitle>

          <Divider />

          <DialogContent dividers>
            {/* First Row */}
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <Typography variant="subtitle1" gutterBottom>
                  Delivered by PM
                </Typography>
              </Grid>

              <Grid item xs={3}>
                Delivered By : {pmName}
              </Grid>

              <Grid item xs={2}>
                At : {currentDate.toLocaleString()}
              </Grid>
            </Grid>

            {/* Second Row: New Grid for TextField */}
            <Grid container spacing={3} style={{ marginTop: 16 }}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Comments"
                  variant="outlined"
                  size="small"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
              </Grid>
            </Grid>
          </DialogContent>


          <DialogActions>
            <Button onClick={handleToggle} color="secondary" variant="outlined">
              Close
            </Button>
            <Button color="primary" variant="contained" onClick={handleSubmitDateDelivered} disabled={isLoadingAddDateDelivered}>
              {isLoadingAddDateDelivered ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Add"
              )}
            </Button>
          </DialogActions>
        </Dialog>
      }
    </>
  );
};